// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__3EDOv","shimmer":"styles_shimmer__3EMdh"};